interface Props {
  children: React.ReactNode;
  className?: string;
}

/**
 * Consistent section label used throughout the homepage.
 * Style: small green dash + uppercase mono label, left-aligned.
 */
export default function SectionTitle({ children, className = "" }: Props) {
  return (
    <div className={`flex items-center justify-center gap-3 mb-6 ${className}`}>
      <span className="w-5 h-px bg-white shrink-0" />
      <span className="text-xs tracking-[0.2em] uppercase text-gray-400">
        {children}
      </span>
      <span className="w-5 h-px bg-white shrink-0" />
    </div>
  );
}
